export const bhsTokens = {
  fontFamily: '"Public Sans", sans-serif',
  colors: {
    primary: '#1677ff',
    primaryHover: '#0958d9'
  },
  shape: {
    borderRadius: 4
  },
  input: {
    height: 52,
    padding: '16px 14px',
    labelFontSize: '1rem',
    floatingLabelFontSize: '0.95rem'
  },
  button: {
    minHeight: 42,
    fontWeight: 500
  },
  menu: {
    itemFontSize: '0.9rem',
    itemFontWeight: 500,
    selectedItemFontWeight: 600,
    iconBoxSize: 34,
    iconFontSize: 18
  }
};
